import React, { useEffect, useState } from 'react';
import { DIMENSION, NAME } from '../../../../utilities/constants/Constants';
import { getUnit } from '../../../../redux/homeActions';
import { unitConverter } from '../../../../redux/actions/sizeHandler';
import { string } from '../../../../localization';

const sizeDropdown = props => {
  const {
    productSizes,
    unitSystem,
    iconFetchHandler,
    displaySize,
    dropdDownSelectionHandler,
    sizeSelectionHandler,
    customSelectionHandler,
    selectedIndex
  } = props;

  const [selectedSizeIndex, setSelectedSizeIndex] = useState(0);

  const dropDownSelectionIsChanged = index => {
    setSelectedSizeIndex(index);
    dropdDownSelectionHandler(index);
  };

  useEffect(() => {
    setSelectedSizeIndex(selectedIndex);
  }, [selectedIndex]);

  let sizeIndexToSet = 0;
  if (
    selectedSizeIndex != 'custom' &&
    selectedSizeIndex < productSizes.default.sizes.length
  ) {
    sizeIndexToSet = selectedSizeIndex;
  }
  return (
    <div className='stacks d-flex justify-content-center align-items-center'>
      {productSizes.default.sizes.length ? (
        <div className='product-wrapper'>
          <button
            type='button'
            className='product-display d-flex justify-content-center align-items-center'
            onClick={() => {
              sizeSelectionHandler(sizeIndexToSet);
            }}
          >
            <img
              alt='Default-Size'
              src={iconFetchHandler(productSizes.default.sizes[sizeIndexToSet])}
            />
          </button>

          <select
            className='border border-secondary mt-3'
            name='wallSelect'
            value={selectedSizeIndex}
            onChange={e => dropDownSelectionIsChanged(e.target.value)}
            style={{ cursor: 'pointer' }}
          >
            {productSizes.default.sizes.map((item, index) => (
              <option key={item.id} value={index}>
                {displaySize !== DIMENSION ? item.name : null}{' '}
                {displaySize !== NAME
                  ? `${unitConverter(
                      item,
                      'width',
                      unitSystem
                    )} x ${unitConverter(item, 'height', unitSystem)} ${getUnit(
                      unitSystem
                    )}`
                  : null}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      {productSizes.custom.sizes ? (
        <div className='product-wrapper'>
          <button
            type='button'
            className='product-display d-flex justify-content-center align-items-center'
            onClick={customSelectionHandler}
          >
            <img alt='Custom-Size' src={productSizes.custom.iconUrl} />
          </button>
          <div className='customText'>{string.CUSTOM_KEY}</div>
        </div>
      ) : null}
    </div>
  );
};

export default sizeDropdown;
